import React, { Fragment, useState, useEffect } from "react";
import { useLocation, useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { Container, Card, Button, Table, Row, Col, Form, Modal, OverlayTrigger, Tooltip} from "react-bootstrap";
import { LoadingComponent } from 'recupero-comunes';
import { formatoMontoCLP } from '../../common/Formatos.js'
import {serviceConsultaHonorarios, serviceGestionaHonoraios, serviceGetDocumento} from '../../api/api-solicitud-honorarios';
import { descargarArchivo } from '../../common/descargarArchivo';
import Mensajes from '../mensajes.js'

const ConfirmarObjetarSolicitudHonorario = ({cfg_form, showModalConfirmar, handleCloseModalConfirmar, honorario, solicitud}) => {

    const [loading, setLoading] = useState(false);
    const [expanded, setExpanded] = useState(true);
    const [comentarios, setComentarios] = useState("");
    const [honorariosHistoricos, setHonorariosHistoricos] = useState([]);

    const ESTADO_HONORARIO_PREAPROBADO = 305004;
    const ESTADO_HONORARIO_RECHAZADO = 305006;

    const [showToast, setShowToast] = useState(false);
    const handleShowToast = () => setShowToast(true) 
    const [respuestaGestion, setRespuestaGestion] = useState({});

    const handleCloseToast = () => {
        setShowToast(false);
        handleCloseModalConfirmar();
        setComentarios("");                    
    }

    const handlePreAprobarObjetar = async (estado) => {
    
        let data = {
            honorario: honorario,
            solicitud : solicitud,
            accion: 2,
            estado: estado,
            comentarios: comentarios
        }

        setLoading(true);
        const response = await serviceGestionaHonoraios(data);
        setLoading(false);

        setRespuestaGestion(response);
        handleShowToast(true);
    }

    useEffect(() => {     
        if (showModalConfirmar) {
            obtieneHonorarios(); 
        }
    }, [showModalConfirmar])

    const obtieneHonorarios = async () => {
        const query = Buffer.from(JSON.stringify({ origenHono: solicitud.idOrigen, idCaso: honorario.idCaso })).toString('base64');
        const honorariosCaso = await serviceConsultaHonorarios(query);
        const nuevaLista = honorariosCaso.filter(item => item.idHonorarioGasto !== honorario.idHonorarioGasto);
        setHonorariosHistoricos(nuevaLista);
        
    }
    const verDocumento = async (honoSelected) => {
    
        try {        
            if (honoSelected.idFolioDoctoHito) {
                setLoading(true); 
                let parametros = JSON.stringify({
                    idCaso: honoSelected.idCaso,
                    idImplicadoCaso: 0,
                    idCompania: honoSelected.idCompania,
                    idfolioCarga: honoSelected.idFolioDoctoHito
                });
                console.log("en handleDocumento...", parametros);
                let query = Buffer.from(parametros).toString('base64')

                const response = await serviceGetDocumento(query);
                setLoading(false);

                descargarArchivo(response);
            }
        } catch (error) {
            console.log("error:", error);
            setLoading(false);
        }
    }
    return (
        <>
        <style type='text/css'>
            {`
                .btn-confirmar{
                  background-color: #C14B49;
                  color: #FFFFFF;
                  width: 140px;
                  padding:6px 0px 6px 0px;
                }
                .btn-confirmar:hover{
                  background-color: #F6897E;
                  color: #FFFFFF;
                }
                .btn-objetar {
                  background-color: #00aeab;
                  color: #FFFFFF;  
                  width: 140px;
                  padding:6px 0px 6px 0px;
                }
                .btn-objetar:hover{
                  background-color: #87c9dc;
                  color: #FFFFFF;
                } 
                thead th {
                    border-bottom: 2px solid #000;
                    position: sticky;
                    top: 0;
                    background: #f8f9fa; /* o el color del header */
                    z-index: 10;        /* para que quede sobre las filas */
                }
            `}
        </style>
            <Fragment>
            <LoadingComponent show={loading} />

                <Modal show={showModalConfirmar} onHide={handleCloseModalConfirmar} backdrop='static' size='xl'>                
                    <Modal.Body>
                        <Card className="mb-3 p-3">
                            <Card.Header className='mt-0 mb-0' as='h6' style={{ backgroundColor: '#4F517A', color: 'white' }}>
                                {(cfg_form && cfg_form["confirma-solicitud-hono-modal-title"]) ? cfg_form["confirma-solicitud-hono-modal-titleing"] : 'Confirmar/Objetar Solicitud Honorario - Caso:'} {honorario?.idCaso}
                            </Card.Header>
                            <Card.Body>
                                <Row>
                                    <Col>
                                        <Form.Label className='mb-0' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                            {(cfg_form && cfg_form["confirma-solicitud-hono-modal-lbl-siniestro"]) ? cfg_form["confirma-solicitud-hono-modal-lbl-siniestro"] : 'Siniestro'}
                                        </Form.Label>
                                        <br />
                                        <Form.Text className='mb-3'>
                                            {honorario ? honorario['siniestro'] : null}
                                        </Form.Text>
                                    </Col>
                                    <Col>
                                        <Form.Label className='mb-0' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                            {(cfg_form && cfg_form["confirma-solicitud-hono-modal-lbl-patente"]) ? cfg_form["confirma-solicitud-hono-modal-lbl-patente"] : 'Patente'}
                                        </Form.Label>
                                        <br />
                                        <Form.Text className='mb-3'>
                                            {honorario ? honorario['patente'] : null}
                                        </Form.Text>
                                    </Col>
                                    <Col>
                                        <Form.Label className='mb-0' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                            {(cfg_form && cfg_form["confirma-solicitud-hono-modal-lbl-fechasin"]) ? cfg_form["confirma-solicitud-hono-modal-lbl-fechasin"] : 'Fecha Siniestro'}
                                        </Form.Label>
                                        <br />
                                        <Form.Text className='mb-3'>
                                            {honorario ? honorario['fechaSiniestroFmt'] : null}
                                        </Form.Text>
                                    </Col>
                                    <Col>
                                        <Form.Label className='mb-0' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                            {(cfg_form && cfg_form["confirma-solicitud-hono-modal-lbl-responsable"]) ? cfg_form["confirma-solicitud-hono-modal-lbl-responsable"] : 'Responsable'}
                                        </Form.Label>
                                        <br />
                                        <Form.Text className='mb-3'>
                                            {solicitud ? solicitud['responsable'] : null}
                                        </Form.Text>
                                    </Col>
                                    <Col>
                                        <Form.Label className='mb-0' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                            {(cfg_form && cfg_form["confirma-solicitud-hono-modal-lbl-fechaasig"]) ? cfg_form["confirma-solicitud-hono-modal-lbl-fechaasig"] : 'Fecha Asignación'}
                                        </Form.Label>
                                        <br />
                                        <Form.Text className='mb-3'>
                                            {honorario ? honorario['fechaSolicitudFmt'] : null}
                                        </Form.Text>
                                    </Col>
                                    <Col>
                                        <Form.Label className='mb-0' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                            {(cfg_form && cfg_form["confirma-solicitud-hono-modal-lbl-gestion"]) ? cfg_form["confirma-solicitud-hono-modal-lbl-gestion"] : 'Tipo Gestión'}
                                        </Form.Label>
                                        <br />
                                        <Form.Text className='mb-3'>
                                            {honorario ? honorario['glosaOrigen'] : null}
                                        </Form.Text>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                        <Card className="mb-3 p-3">
                              <Card.Header className='mt-0 mb-0' as='h6' style={{ backgroundColor: '#4F517A', color: 'white' }} onClick={() => setExpanded(!expanded)}>
                                  {expanded ? "▼" : "▶"} {(cfg_form && cfg_form["confirma-solicitud-hono-modal-hitorial-subtitle"]) ? cfg_form["confirma-solicitud-hono-modal-hitorial-subtitle"] : 'Historial Solicitud de Honorarios'}
                              </Card.Header>
                              {expanded && (
                                <Card.Body style={{ maxHeight: "300px", overflowY: "auto" }}>
                                    <Table striped bordered hover>
                                        <thead>
                                            <tr>
                                                <th>{(cfg_form && cfg_form["confirma-solicitud-hono-modal-hitorial-idsol"]) ? cfg_form["confirma-solicitud-hono-modal-hitorial-idsol"] : 'ID Solictud'}</th>
                                                <th>{(cfg_form && cfg_form["confirma-solicitud-hono-modal-hitorial-concepto"]) ? cfg_form["confirma-solicitud-hono-modal-hitorial-concepto"] : 'Concepto a Facturar'}</th>
                                                <th>{(cfg_form && cfg_form["confirma-solicitud-hono-modal-hitorial-fechahab"]) ? cfg_form["confirma-solicitud-hono-modal-hitorial-fechahab"] : 'Fecha Habilitado'}</th>
                                                <th>{(cfg_form && cfg_form["confirma-solicitud-hono-modal-hitorial-fechasol"]) ? cfg_form["confirma-solicitud-hono-modal-hitorial-fechasol"] : 'Fecha Solicitud'}</th>
                                                <th>{(cfg_form && cfg_form["confirma-solicitud-hono-modal-hitorial-montonetohab"]) ? cfg_form["confirma-solicitud-hono-modal-hitorial-montonetohab"] : 'Monto Neto Habilitado'}</th>
                                                <th>{(cfg_form && cfg_form["confirma-solicitud-hono-modal-hitorial-montofactura"]) ? cfg_form["confirma-solicitud-hono-modal-hitorial-montofactura"] : 'Monto a Facturar s/Iva'}</th>
                                                <th>{(cfg_form && cfg_form["confirma-solicitud-hono-modal-hitorial-situacion"]) ? cfg_form["confirma-solicitud-hono-modal-hitorial-situacion"] : 'Situación'}</th>
                                                <th>{(cfg_form && cfg_form["confirma-solicitud-hono-modal-hitorial-verdocto"]) ? cfg_form["cconfirma-solicitud-hono-modal-hitorial-verdocto"] : 'Ver Docto'}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {honorariosHistoricos?.map((hono) => (
                                                <tr key={hono.Id}>                        
                                                    <td>{hono.idSolicitud}</td>
                                                    <td>{hono.glosaConcepto}</td>
                                                    <td>{hono.fechaHabilitadoFmt}</td>
                                                    <td>{solicitud.fechaSolicitudFmt}</td>
                                                    <td>{formatoMontoCLP(hono.montoFacturar)}</td>                                    
                                                    <td>{formatoMontoCLP(hono.montoNetoFacturado)}</td>
                                                    <td>{hono.glosaSituacion}</td>
                                                    <td>         
                                                       <a 
                                                            href="#"
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                if (!hono.idFolioDoctoHito) {                                
                                                                    return;
                                                                }
                                                                verDocumento(hono); 
                                                            }}  
                                                            style={{ display: 'flex', alignItems: 'center', marginTop: '10px', 
                                                                color: !hono.idFolioDoctoHito ? 'gray' : 'red',
                                                                pointerEvents: !hono.idFolioDoctoHito ? 'none' : 'auto',
                                                                opacity: !hono.idFolioDoctoHito ? 0.5 : 1
                                                            }}
                                                            >
                                                            {/* SVG como ícono */}
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" className="bi bi-file-earmark-pdf" viewBox="0 0 20 20">
                                                                <path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2M9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5z"/>
                                                                <path d="M4.603 14.087a.8.8 0 0 1-.438-.42c-.195-.388-.13-.776.08-1.102.198-.307.526-.568.897-.787a7.7 7.7 0 0 1 1.482-.645 20 20 0 0 0 1.062-2.227 7.3 7.3 0 0 1-.43-1.295c-.086-.4-.119-.796-.046-1.136.075-.354.274-.672.65-.823.192-.077.4-.12.602-.077a.7.7 0 0 1 .477.365c.088.164.12.356.127.538.007.188-.012.396-.047.614-.084.51-.27 1.134-.52 1.794a11 11 0 0 0 .98 1.686 5.8 5.8 0 0 1 1.334.05c.364.066.734.195.96.465.12.144.193.32.2.518.007.192-.047.382-.138.563a1.04 1.04 0 0 1-.354.416.86.86 0 0 1-.51.138c-.331-.014-.654-.196-.933-.417a5.7 5.7 0 0 1-.911-.95 11.7 11.7 0 0 0-1.997.406 11.3 11.3 0 0 1-1.02 1.51c-.292.35-.609.656-.927.787a.8.8 0 0 1-.58.029m1.379-1.901q-.25.115-.459.238c-.328.194-.541.383-.647.547-.094.145-.096.25-.04.361q.016.032.026.044l.035-.012c.137-.056.355-.235.635-.572a8 8 0 0 0 .45-.606m1.64-1.33a13 13 0 0 1 1.01-.193 12 12 0 0 1-.51-.858 21 21 0 0 1-.5 1.05zm2.446.45q.226.245.435.41c.24.19.407.253.498.256a.1.1 0 0 0 .07-.015.3.3 0 0 0 .094-.125.44.44 0 0 0 .059-.2.1.1 0 0 0-.026-.063c-.052-.062-.2-.152-.518-.209a4 4 0 0 0-.612-.053zM8.078 7.8a7 7 0 0 0 .2-.828q.046-.282.038-.465a.6.6 0 0 0-.032-.198.5.5 0 0 0-.145.04c-.087.035-.158.106-.196.283-.04.192-.03.469.046.822q.036.167.09.346z"/>
                                                            </svg>
                                                        </a>     
                                                    </td>
                                                </tr>
                                            ))}                            
                                            </tbody>
                                    </Table>
                                </Card.Body>
                                )}
                        </Card>
                        <Card className="mb-3 p-3">
                            <Card.Header className='mt-0 mb-0' as='h6' style={{ backgroundColor: '#4F517A', color: 'white' }}>
                                {(cfg_form && cfg_form["confirma-solicitud-hono-modal-detalle-title"]) ? cfg_form["confirma-solicitud-hono-modal-detalle-title"] : 'Solicitud Honorario por Confirmar/Objetar - Solicitud:'} {honorario?.idSolicitud}
                            </Card.Header>
                            <Card.Body>
                                <Row>
                                    <Col>
                                        <Form.Label className='mb-0' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                            {(cfg_form && cfg_form["confirma-solicitud-hono-modal-detalle-lbl-siniestro"]) ? cfg_form["confirma-solicitud-hono-modal-detalle-lbl-siniestro"] : 'Siniestro'}
                                        </Form.Label>
                                        <br />
                                        <Form.Text className='mb-3'>
                                            {honorario ? honorario['siniestro'] : null}
                                        </Form.Text>
                                    </Col>
                                    <Col>
                                        <Form.Label className='mb-0' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                            {(cfg_form && cfg_form["confirma-solicitud-hono-modal-detalle-lbl-patente"]) ? cfg_form["confirma-solicitud-hono-modal-detalle-lbl-patente"] : 'Patente'}
                                        </Form.Label>
                                        <br />
                                        <Form.Text className='mb-3'>
                                            {honorario ? honorario['patente'] : null}
                                        </Form.Text>
                                    </Col>
                                    <Col>
                                        <Form.Label className='mb-0' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                            {(cfg_form && cfg_form["confirma-solicitud-hono-modal-detalle-lbl-origen"]) ? cfg_form["confirma-solicitud-hono-modal-detalle-lbl-origen"] : 'Origen'}
                                        </Form.Label>
                                        <br />
                                        <Form.Text className='mb-3'>
                                            {honorario ? honorario['glosaOrigen'] : null}
                                        </Form.Text>
                                    </Col>
                                    <Col>
                                        <Form.Label className='mb-0' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                            {(cfg_form && cfg_form["confirma-solicitud-hono-modal-detalle-lbl-concepto"]) ? cfg_form["confirma-solicitud-hono-modal-detalle-lbl-concepto"] : 'Concepto a Facturar'}
                                        </Form.Label>
                                        <br />
                                        <Form.Text className='mb-3'>
                                            {honorario ? honorario['glosaConcepto'] : null}
                                        </Form.Text>
                                    </Col>
                                    <Col>
                                        <Form.Label className='mb-0' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                            {(cfg_form && cfg_form["confirma-solicitud-hono-modal-detalle-lbl-fechahito"]) ? cfg_form["confirma-solicitud-hono-modal-detalle-lbl-fechahito"] : 'Fecha Hito'}                                            
                                        </Form.Label>
                                        <br />
                                        <Form.Text className='mb-3'>
                                            {honorario ? honorario['fechaHabilitadoFmt'] : null}
                                            <a 
                                                href="#"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    if (!honorario.idFolioDoctoHito) {                                
                                                        return;
                                                    }
                                                    verDocumento(honorario); 
                                                }}  
                                                style={{ display: 'flex', alignItems: 'center', marginTop: '10px', 
                                                    color: !honorario.idFolioDoctoHito ? 'gray' : 'red',
                                                    pointerEvents: !honorario.idFolioDoctoHito ? 'none' : 'auto',
                                                    opacity: !honorario.idFolioDoctoHito ? 0.5 : 1
                                                }}
                                                >
                                                {/* SVG como ícono */}
                                                <svg xmlns="http://www.w3.org/2000/svg" width="30" height="25" fill="currentColor" className="bi bi-file-earmark-pdf" viewBox="0 0 20 20">
                                                    <path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2M9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5z"/>
                                                    <path d="M4.603 14.087a.8.8 0 0 1-.438-.42c-.195-.388-.13-.776.08-1.102.198-.307.526-.568.897-.787a7.7 7.7 0 0 1 1.482-.645 20 20 0 0 0 1.062-2.227 7.3 7.3 0 0 1-.43-1.295c-.086-.4-.119-.796-.046-1.136.075-.354.274-.672.65-.823.192-.077.4-.12.602-.077a.7.7 0 0 1 .477.365c.088.164.12.356.127.538.007.188-.012.396-.047.614-.084.51-.27 1.134-.52 1.794a11 11 0 0 0 .98 1.686 5.8 5.8 0 0 1 1.334.05c.364.066.734.195.96.465.12.144.193.32.2.518.007.192-.047.382-.138.563a1.04 1.04 0 0 1-.354.416.86.86 0 0 1-.51.138c-.331-.014-.654-.196-.933-.417a5.7 5.7 0 0 1-.911-.95 11.7 11.7 0 0 0-1.997.406 11.3 11.3 0 0 1-1.02 1.51c-.292.35-.609.656-.927.787a.8.8 0 0 1-.58.029m1.379-1.901q-.25.115-.459.238c-.328.194-.541.383-.647.547-.094.145-.096.25-.04.361q.016.032.026.044l.035-.012c.137-.056.355-.235.635-.572a8 8 0 0 0 .45-.606m1.64-1.33a13 13 0 0 1 1.01-.193 12 12 0 0 1-.51-.858 21 21 0 0 1-.5 1.05zm2.446.45q.226.245.435.41c.24.19.407.253.498.256a.1.1 0 0 0 .07-.015.3.3 0 0 0 .094-.125.44.44 0 0 0 .059-.2.1.1 0 0 0-.026-.063c-.052-.062-.2-.152-.518-.209a4 4 0 0 0-.612-.053zM8.078 7.8a7 7 0 0 0 .2-.828q.046-.282.038-.465a.6.6 0 0 0-.032-.198.5.5 0 0 0-.145.04c-.087.035-.158.106-.196.283-.04.192-.03.469.046.822q.036.167.09.346z"/>
                                                </svg>
                                            </a>
                                        </Form.Text>
                                    </Col>
                                </Row>
                                <br />
                                <Row>
                                    <Col>
                                        <Form.Label className='mb-0' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                            {(cfg_form && cfg_form["confirma-solicitud-hono-modal-detalle-lbl-mtonetohab"]) ? cfg_form["confirma-solicitud-hono-modal-detalle-lbl-mtonetohab"] : 'HO Neto Habilitado'}
                                        </Form.Label>
                                        <br />
                                        <Form.Text className='mb-3'>
                                            {honorario ? formatoMontoCLP(honorario['montoFacturar']) : null}
                                        </Form.Text>
                                    </Col>
                                    <Col>
                                        <Form.Label className='mb-0' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                            {(cfg_form && cfg_form["confirma-solicitud-hono-modal-detalle-lbl-mtonetofactura"]) ? cfg_form["confirma-solicitud-hono-modal-detalle-lbl-mtonetofactura"] : 'Neto a Facturar'}
                                        </Form.Label>
                                        <br />
                                        <Form.Text className='mb-3'>
                                            {honorario ? formatoMontoCLP(honorario['montoNetoFacturado']) : null}
                                        </Form.Text>
                                    </Col>
                                    <Col>
                                        <Form.Label className='mb-0' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                            {(cfg_form && cfg_form["confirma-solicitud-hono-modal-detalle-lbl-mtonetodif"]) ? cfg_form["confirma-solicitud-hono-modal-detalle-lbl-mtonetodif"] : 'Neto Diferencia'}
                                        </Form.Label>
                                        <br />
                                        <Form.Text className='mb-3'>
                                            {honorario ? formatoMontoCLP(honorario['montoNetoFacturado'] - honorario['montoFacturar']) : null}
                                        </Form.Text>
                                    </Col>
                                    <Col>
                                        <Form.Label className='mb-0' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                            {(cfg_form && cfg_form["confirma-solicitud-hono-modal-detalle-lbl-situacion"]) ? cfg_form["confirma-solicitud-hono-modal-detalle-lbl-situacion"] : 'Situación'}
                                        </Form.Label>
                                        <br />
                                        <Form.Text className='mb-3'>
                                            {honorario ? honorario['glosaSituacion'] : null}
                                        </Form.Text>
                                    </Col>
                                    <Col>
                                        <Form.Label className='mb-0' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                            {(cfg_form && cfg_form["confirma-solicitud-hono-modal-detalle-lbl-fechasit"]) ? cfg_form["confirma-solicitud-hono-modal-detalle-lbl-fechasit"] : 'Fecha Situación'}
                                        </Form.Label>
                                        <br />
                                        <Form.Text className='mb-3'>
                                            {honorario ? honorario['fechaSituacionFmt'] : null}
                                        </Form.Text>
                                    </Col>
                                </Row>
                                <br />
                                <Row>
                                    <Col>
                                        <Form.Label className='mb-0' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                            {(cfg_form && cfg_form["confirma-solicitud-hono-modal-detalle-lbl-comensol"]) ? cfg_form["confirma-solicitud-hono-modal-detalle-lbl-comensol"] : 'Comentario Solicitante'}
                                        </Form.Label>
                                        <br />
                                        <Form.Text className='mb-3'>
                                            {honorario ? honorario['comentarioCambMonto'] : null}
                                        </Form.Text>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md='12'>
                                        <Form.Label className='mt-3' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                            {(cfg_form && cfg_form["confirma-solicitud-hono-modal-detalle-input-comentario"]) ? cfg_form["confirma-solicitud-hono-modal-detalle-input-comentario"] : 'Comentario CIA'}
                                        </Form.Label>
                                        <Form.Control className='mb-2'
                                            as="textarea"
                                            rows={2}
                                            value={comentarios}
                                            onChange={(e) => setComentarios(e.target.value)}
                                            placeholder="Comentarios..."
                                        />
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                    </Modal.Body>
                    <Container>
                        <Row>
                            <Col>
                                {respuestaGestion && 
                                    <Mensajes
                                        showToast={showToast}
                                        handleCloseToast={handleCloseToast}
                                        delay={3000}
                                        responseData={respuestaGestion}
                                    ></Mensajes>
                                }
                            </Col>
                        </Row>
                    </Container>
                    <Modal.Footer> 
                        <Button className='me-md-2' variant='outline-info' type='button' onClick={handleCloseModalConfirmar}>{(cfg_form && cfg_form["confirma-solicitud-hono-modal-btn-volver"]) ? cfg_form["confirma-solicitud-hono-modal-btn-volver"] : 'Volver'}</Button>
                        <Button variant='objetar' type='button' onClick={() => { handlePreAprobarObjetar(ESTADO_HONORARIO_RECHAZADO) }}>{(cfg_form && cfg_form["confirma-solicitud-hono-modal-btn-objetar"]) ? cfg_form["confirma-solicitud-hono-modal-btn-objetar"] : 'Objetar'}</Button>         
                        <Button variant='confirmar' type='button' onClick={() => { handlePreAprobarObjetar(ESTADO_HONORARIO_PREAPROBADO) }}>{(cfg_form && cfg_form["confirma-solicitud-hono-modal-btn-preaprob"]) ? cfg_form["confirma-solicitud-hono-modal-btn-preaprob"] : 'Pre-Aprobado'}</Button>         
                    </Modal.Footer>
                </Modal>
            </Fragment>

        </>
    );
};
export default ConfirmarObjetarSolicitudHonorario;

